import React, { useEffect } from "react";
import { Accordion } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import "./EventFaqSection.css";
import faq1 from '../assets/event-18.jpg';
import faq2 from '../assets/event-11.jpg';

const EventFaqSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="event-faq-section">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Side */}
          <div className="col-md-6 mb-4 mb-md-0">
            <div data-aos="fade-right" data-aos-delay="100">
              <h6 className="event-faq-title mb-2">Featured FAQs</h6>
              <h2 className="event-faq-heading mb-3">
                Addressing Common Questions For Our Events.
              </h2>
              <p className="event-faq-description">
  We’re here to answer your most common questions about our corporate event services. Whether you need help with planning, logistics, or customization options, our team provides clear and timely support to ensure your event runs smoothly.
</p>
            </div>

            <div className="d-flex2 gap-5" data-aos="zoom-in" data-aos-delay="200">
              <img src={faq1} alt="Event 1" className="event-faq-image" />
            </div>
          </div>

          {/* Right Side */}
          <div className="col-md-6">
            <div className="d-flex3 gap-3" data-aos="fade-left" data-aos-delay="150">
              <img src={faq2} alt="Event 2" className="event-faq-image" />
            </div>

            {/* Accordion (no animation) */}
            <Accordion defaultActiveKey="0" flush>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  What types of events do you specialize in?
                </Accordion.Header>
                <Accordion.Body>
                  Far far away, behind the word mountains, far from the countries Vokalia and
                  Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  How far in advance should I book?
                </Accordion.Header>
                <Accordion.Body>
                  We recommend booking at least 3-6 months in advance to secure availability and allow ample planning time.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  Do you offer customizable packages?
                </Accordion.Header>
                <Accordion.Body>
                  Yes, we tailor our services to suit your specific event needs, themes, and budgets.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventFaqSection;
